import { truncateWithEllipsis } from '@/domain/common/format'
import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { formatCompact } from '@/domain/types/Token'
import { Dash } from '@/ui/atoms/dash/Dash'

interface InWalletCellProps {
  amount?: number
  symbol?: string
}

export function InWalletCell({ amount, symbol }: InWalletCellProps) {
  if (amount === undefined || amount <= 0) {
    return (
      <div className="text-right">
        <Dash />
      </div>
    )
  }

  const formatted = formatCompact(NormalizedUnitNumber(amount), 2)

  return (
    <div className="flex flex-col items-end text-right">
      <span className="font-medium text-foreground text-sm">{formatted}</span>
      {symbol && <span className="ml-1 text-muted-foreground text-xs">{truncateWithEllipsis(symbol, 8)}</span>}
    </div>
  )
}
